import styled from "styled-components";

export const SectionWrap = styled.div`
    padding-block-start: 60px;
    padding-block-end: 60px;
`;
